
const Css = {
  topMenu: {
    width: "100%",
    height: "40px",
    float: "left",
    marginBottom: "2px",
    backgroundColor: "#121212"
  },
  ctrArea: {
    width: "230px",
    height: "40px",
    backgroundColor: "#252525",
    float: "left",
  },
  ctrBtn: {
    // width: "134px",
    height: "24px",
    lineHeight: "24px",
    color: "#fff",
    borderRadius: "4px",
    backgroundColor: "#FF2D89",
    fontFamily: "OpenSans-Semibold",
    fontSize: "12px",
    textAlign: "center",
    margin: "8px 0 0 20px",
    cursor: "pointer",
    float: "left",
    padding: "0 10px",
  },
  ctrTip: {
    width: "218px",
    height: "24px",
    lineHeight: "24px",
    margin: "8px 8px 0 10px"
  },
  remoteLogo: {
    width: "16px",
    height: "16px",
    float: "left",
    margin: "4px 8px 0 0"
  },
  conStatusTip:{
    fontSize: "12px",
    height: "24px",
    lineHeight: "24px",
    textAlign: "left",
    color: "#ccc",
    fontFamily: "OpenSans-Semibold",
  },
  titleArea(width){
    return {
      width: width + "px",
      height: "40px",
      float: "left",
      backgroundColor: "#252525",
    }
  },
  ptTitle(width, editorMode, rightNavsWidth){
    // let w = 0;
    // if(editorMode.edMode === 2){
    //   w = (width + rightNavsWidth);
    // }else{
    //   w = width;
    // }
    let w = width;
    return {
      width: w + "px",
      textAlign: "center",
      height: "40px",
      lineHeight: "40px",
      fontSize: "14px",
      color: editorMode.edMode === 2 ? "#E6A23C" : "#ccc",
      float: "left",
      marginLeft: "0px",
      backgroundColor: "#252525",
      fontFamily: "OpenSans-Semibold",
    }
  },
  rightNavs(rightNavsWidth){
    return {
      width: rightNavsWidth + "px",
      height: "40px",
      float: "left",
    }
  },
  backArea: {
    width: "230px",
    height: "40px",
    float: "left",
    backgroundColor: "#252525",
  },
  backBtn: {
    width: "100px",
    height: "40px",
    lineHeight: "40px",
    float: "left",
    cursor: "pointer",
  },
  rightMbtn: {
    display: "inline-block",
    fontFamily: "OpenSans",
    fontSize: "12px",
    color: "#ccc",
    height: "40px",
    lineHeight: "40px",
    float: "right",
    margin: "0 20px 0 0",
    cursor: "pointer",
  },
  backTxt: {
    fontFamily: "OpenSans",
    fontSize: "13px",
    color: "#999",
    height: "40px",
    lineHeight: "40px",
    float: "left",
  },
  previewArea(w){
    return {
      width: w + "px",
      height: "40px",
      float: "right",
      backgroundColor: "#252525",
      userSelect: "none",
      prevBtn: {
        width: (w-30) + "px",
        height: "40px",
        float: "left",
        cursor: "pointer",
        fontFamily: "OpenSans",
      },
      prevBtnImg: {
        width: "16px",
        height: "16px",
        borderRadius: "50%",
        margin: "12px 8px 0 12px",
        float: "left"
      },
      conTipImg: {
        width: "16px",
        height: "16px",
        borderRadius: "50%",
        margin: "12px 12px 0 0",
        float: "right",
        cursor: "pointer"
      },
      txt: {
        width: "80px",
        height: "40px",
        lineHeight: "40px",
        textAlign: "left",
        color: "#ccc",
        fontSize: "13px",
        float: "left",
      }
    }
  },
  backImg: {
    margin: "14px 10px 0 20px",
    height: "11px",
    float: "left"
  }
}

export default Css;